import { getCommonWidget } from '../dashWidgetHelper'
import { commonWidgets } from "./commonWidgetsCaffenio";

export default {
    title: 'Apertura Dashboard',
    description: 'Apertura Default',
    widgets: (filters: FiltersUI) => [

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'lineDetailedByMonthAndGeo',
            title: "Satisfacción General",
            size: [4, 4],
            extraConfigs: {
                backgroundColor: 'transparent',
                theme: 'dark',
            },
            indicator: 'lealtad_csat',
            criticalMomentId: 24101
        }),

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'multipleTrendByMonth',
            title: 'Satisfacción General',
            size: [1, 2],
            indicator: 'lealtad_csat',
            criticalMomentInclude: [24101],
            extraConfigs: {
                useCurrent: 0,
            }
        }),

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'multipleTrendByMonth',
            title: 'NPS General',
            size: [1, 2],
            indicator: 'lealtad_nps',
            criticalMomentInclude: [24101],
            extraConfigs: {
                useCurrent: 0,
            }
        }),

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'multipleTrendByMonth',
            title: 'Disposición a regresar',
            size: [2, 2],
            indicator: 'lealtad_willingness_to_return',
            criticalMomentInclude: [24101],
            extraConfigs: {
                useCurrent: 0,
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'mapByGeos',
            title: 'Mapa puntos de ventas',
            size: [2, 2],
            criticalMomentId: 24101,
            indicator: 'lealtad_csat',
        }),

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Atributos de satisfacción',
            size: [2, 2],
            indicator: 'lealtad_csat_atributo',
            criticalMomentInclude: [24101],
            extraConfigs: {
                center: ['40%', '55%'],
                itemGap: 8,
            },
        }),

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'wordCount',
            title: 'Comentarios',
            size: [2, 2],
            indicator: 'lealtad_comment_exp',
            criticalMomentInclude: [24101],
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'wordCountWithLinks',
            title: 'Nube de Palabras / Frecuencia en comentarios',
            size: [2, 2],
            criticalMomentId: 24101,
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'textAnalysis',
            title: 'Analisis de Sentimientos',
            size: [4, 4],
            indicator: "SENTIMENT",
            criticalMomentId: 24101
        }),

    ]
}
